import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {CustomPayout} from '../../models/custom-payout';

@Injectable({
  providedIn: 'root'
})
export class CustomPayoutService extends AbstractModelService<CustomPayout> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/custom-payout', CustomPayout);
  }
}
